<mat-list-item class="duplicate-row auto-height">
    <div class="pair-shell">
        <div class="confidence-bar">
            <span
                class="confidence"
                [class.confidence-high]="row.confidenceBand === 'High'"
                [class.confidence-medium]="row.confidenceBand === 'Medium'"
                [class.confidence-low]="row.confidenceBand === 'Low'"
                [attr.title]="'Match confidence: ' + row.confidence + '%'">
                {{ row.confidence }}% · {{ row.confidenceBand }}
            </span>
        </div>

        <div class="pair-columns">
            <div class="pane-column">
                <span *ngIf="mergeUiEnabled" class="drag-handle" draggable="true"
                    (dragstart)="onDragStart($event, row.primaryPatient)"
                    title="Drag onto the other patient to merge"
                    aria-label="Drag to merge into the other patient in this pair">
                    <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                </span>
                <button type="button" class="patient-pane"
                    (click)="navigateToPatient($event, row.primaryPatient)"
                    (dragover)="onDragOver($event)"
                    (drop)="onDrop($event, row.primaryPatient)">
                    <span class="pane-inner">
                        <span class="pane-row">
                            <span class="status-chip" *ngIf="row.primaryPatient.status === 'invite'">Invite</span>
                            <span class="status-chip file-chip" *ngIf="row.primaryPatient.status !== 'invite'">File</span>
                            <span class="pane-text">
                                <b>{{ row.primaryPatient.surname }}, {{ row.primaryPatient.name }}</b>
                                <span class="file-num">({{ row.primaryPatient.patientNumber || '—' }})</span>
                            </span>
                            <mat-icon class="pane-eye" aria-hidden="true">visibility</mat-icon>
                        </span>
                        <div class="pane-created" *ngIf="row.primaryPatient.createdAt">
                            Created {{ row.primaryPatient.createdAt | date: 'dd/MM/yyyy, HH:mm' }}
                        </div>
                        <ul class="pane-match-lines" *ngIf="primaryPaneMatchLines.length" aria-label="Matching fields">
                            <li *ngFor="let m of primaryPaneMatchLines" class="pane-match-line">
                                <span class="pml-label">{{ m.label }}</span>
                                <span class="pml-value">{{ m.value }}</span>
                            </li>
                        </ul>
                    </span>
                </button>
            </div>

            <div class="pane-divider" aria-hidden="true"></div>

            <div class="pane-column">
                <span *ngIf="mergeUiEnabled" class="drag-handle" draggable="true"
                    (dragstart)="onDragStart($event, row.otherPatient)"
                    title="Drag onto the other patient to merge"
                    aria-label="Drag to merge into the other patient in this pair">
                    <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                </span>
                <button type="button" class="patient-pane"
                    (click)="navigateToPatient($event, row.otherPatient)"
                    (dragover)="onDragOver($event)"
                    (drop)="onDrop($event, row.otherPatient)">
                    <span class="pane-inner">
                        <span class="pane-row">
                            <span class="status-chip" *ngIf="row.otherPatient.status === 'invite'">Invite</span>
                            <span class="status-chip file-chip" *ngIf="row.otherPatient.status !== 'invite'">File</span>
                            <span class="pane-text">
                                <b>{{ row.otherPatient.surname }}, {{ row.otherPatient.name }}</b>
                                <span class="file-num">({{ row.otherPatient.patientNumber || '—' }})</span>
                            </span>
                            <mat-icon class="pane-eye" aria-hidden="true">visibility</mat-icon>
                        </span>
                        <div class="pane-created" *ngIf="row.otherPatient.createdAt">
                            Created {{ row.otherPatient.createdAt | date: 'dd/MM/yyyy, HH:mm' }}
                        </div>
                        <ul class="pane-match-lines" *ngIf="otherPaneMatchLines.length" aria-label="Matching fields">
                            <li *ngFor="let m of otherPaneMatchLines" class="pane-match-line">
                                <span class="pml-label">{{ m.label }}</span>
                                <span class="pml-value">{{ m.value }}</span>
                            </li>
                        </ul>
                    </span>
                </button>
            </div>
        </div>

        <p class="match-summary">{{ matchSummaryText }}</p>
    </div>
</mat-list-item>
